import {
  Component,
  Output,
  Input,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";

@Component({
  selector: "icn-number-input",
  templateUrl: "./number-input.component.html",
  styleUrls: ["./number-input.component.scss"],
})
export class NumberInputComponent {
  @Input()
  useDefaultHtmlInput = false;

  @Input()
  value: number;

  @Input()
  disabled = false;

  @Input()
  pattern = "[0-9]*";

  @Input()
  maxLength = 100;

  @Input()
  minLength = 0;

  @Input()
  sign = "";

  @Input()
  allowOnlyButtonUpdates = false;

  @Input()
  step = 1;

  @Input()
  min: number;

  @Input()
  max: number;

  @Input()
  theme = "white";

  @Input()
  roundToStep = false;

  @Input()
  contentEditable = true;

  @Output()
  valueChange = new EventEmitter<number>();

  @ViewChild('inputEl')
  inputEl: ElementRef<HTMLInputElement>;

  round(value, step) {
    step || (step = 1.0);
    var inv = 1.0 / step;
    return Math.round(value * inv) / inv;
  }

  increment() {
    if (this.disabled) {
      return;
    }
    let val = this.value + this.step;
    if (val > this.max) {
      val = this.max;
    }
    if (this.roundToStep) {
      val = this.round(val, this.step);
    }
    this.value = val;
    this.valueChange.emit(val);
  }

  decrement() {
    if (this.disabled) {
      return;
    }
    let val = this.value - this.step;
    if (val < this.min) {
      val = this.min;
    }
    if (this.roundToStep) {
      val = this.round(val, this.step);
    }
    this.value = val;
    this.valueChange.emit(val);
  }

  onKeyPress(val) {
    if (this.allowOnlyButtonUpdates) {
      return false;
    }
    return true;
  }
  onValueChange(val) {
    if (
      val === null ||
      val === undefined ||
      Number.isNaN(val) ||
      this.disabled
    ) {
      return;
    }
    let clamped = val;
    if (val < this.min) {
      clamped = this.min;
    } else if (val > this.max) {
      clamped = this.max;
    }
    this.value = clamped;
    if (clamped !== val && this.inputEl?.nativeElement) {
      this.inputEl.nativeElement.value = String(clamped);
    }
    this.valueChange.emit(this.value);
  }
}
